import React from 'react';
import banner from '../../img/banner-img.png';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import WelfareSection from './WelfareSection';

const BannerSection = () => {
    return (
        <>
        <section className="banner-section hero_banner">
            <div className="image-relative">
                <div className="image-banner">
                    <img src={banner} alt="Banner" />
                    <div className="banner-content">
                        <h1 className="banner-title"><span>Humanity is the biggest Religion</span> <span>Helping others is the biggest Job</span> <span>Being kind to others will Solve more then half of Problems</span> <span>Trying to Look For Solution will Solve the Remaining half</span> </h1>
                    </div>
                </div>
            </div>
        </section>
        <WelfareSection />
           
        </>
    );
};

export default BannerSection;
